import { constants, typographyStyles } from "@newsela/angelou";

const {
  textSObj,
  heading5Obj: { fontSize: heading5FontSize },
} = typographyStyles;

const greyDark = constants.colors.ui.neutral[700];

export const rootCss = {
  position: "relative",
  display: "flex",
  flexWrap: "wrap",
  padding: "6px 0",
};

export const iconCss = {
  width: "25px",

  path: {
    stroke: greyDark,
  },

  "path:last-child": {
    fill: greyDark,
  },
};

export const nameHeadingCss = {
  fontSize: heading5FontSize,
  margin: "8px 0 8px 8px",
};

export const textCss = {
  ...textSObj,
  marginLeft: "33px",
  width: "100%",
  whiteSpace: "pre-line",
};

export const nameAndActionsCss = {
  display: "flex",
  width: "100%",
};
